import { defineComponent } from '@vue/composition-api';
import AIPageDiff from '@/components/version/aiPageDiff';
/**
 * AI 冲突已解决 / 无冲突合并视图
 * 复用版本变更的 AIPageDiff，按 mainBranch 展示文件级 Diff
 */
export default defineComponent({
    name: 'AIConflictResolvedView',
    props: {
        originalData: {
            type: Object,
            default: () => ({}),
        },
        modifiedData: {
            type: Object,
            default: () => ({}),
        },
    },
    render() {
        return (<div class="w-full h-[calc(100vh-230px)] overflow-hidden">
        <AIPageDiff originalData={this.originalData} modifiedData={this.modifiedData}/>
      </div>);
    },
});
